<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"

defineProps<{
  route: RouteLocationRaw
}>()
</script>

<template>
  <NuxtLink
    :to="route"
    active-class="bg-zinc-100"
    class="-m-3 flex items-center rounded-md p-3 text-base font-medium hover:bg-zinc-100"
  >
    <slot />
  </NuxtLink>
</template>
